import React from "react";

const InnerItem = props => {
    let item = props.itemSelected ? props.itemSelected : null;

    return (
        <div className={`vote-container${props._EndScreen && !props.isActive ? " unselected" : ""}${props.isActive ? " active" : ""}`} onClick={() => {
            props.selectOption ? props.selectOption(props.index) : null;
            props.onClick ? props.onClick(props.index) : null;
            if (props._EndScreen) {
                if (props.isActive) {
                    props.deleteCategory ? props.deleteCategory(props.index) : null;
                } else {
                    props.OwlRef ? props.OwlRef.to(props.index, 0) : null;
                }
            }
        }}>
            <div className={`vote image-${props.Image}`} title={`צילום: ${props.ImageCredit}`}>
                <div className="crown">{props._EndScreen && !props.isActive ? "+" : ""}</div>
                <div onClick={() => {
                    if (props._EndScreen) {
                        if (props.isActive) {
                            props.deleteCategory ? props.deleteCategory(props.index) : null;
                        } else {
                            props.OwlRef ? props.OwlRef.to(props.index, 0) : null;
                        }
                    }
                }} className={`selection ${props.isActive ? (item == null ? "v" : "x") : "plus"}`}></div>
            </div>
            <div className="bio">
                {props.CategoryName ?
                    <div className="category">{props.CategoryName}</div> : ""}
                <div className="name">
                    {props.Name}
                </div>
                <div className="desc">
                    {props.Owner ? `(${props.Owner})` : props.Owner}
                </div>
            </div>
        </div >
    )
}

const InnerHeader = props => {
    return (
        <div className="innerheader">
            <div className="text">{props.name}</div>
            <div className="smallcrown"></div>
            <div className="frogiicon"></div>
        </div>
    )
}

export {
    InnerHeader,
    InnerItem
}


// WEBPACK FOOTER //
// ./src/Components/Common/Slide/Inners.jsx